<template>
  <div>
    <el-row style="background-color: #ececee" class="hidden-sm-and-down heigh-contenedor">
      <!-- <div class="hidden-md-and-up">
        <el-col :md="14" :sm="24" :xs="24" class="padding-box" style="display: flex !important; align-items: center !important">
          <div class="hidden-md-and-up contenedor-flex card-sumate" style="display: flex !important; align-items: center !important; display: grid; align-items: center; margin-top: 0%">
            <p class="msj_cultura texto-sumate">{{ $t('comercial.title_1') }} <span style="color: #d35915" v-html="$t('comercial.title_2')"></span></p>
          </div>
        </el-col>
        <el-col :md="10" :sm="24" :xs="24" class="hidden-md-and-up columna heigh-contenedor" style="display: grid !important; align-items: center !important">
          <div class="hidden-md-and-up" style="/* o la medida que estés usando */ position: absolute">
            <el-button style="width: 100%" class="title2" type="warning" @click="showForm" v-html="$t('comercial.btn_comercial')"></el-button>
          </div>
        </el-col>
      </div> -->
      <div class="hidden-sm-and-down">
        <el-col :md="14" :sm="24" :xs="24" class="padding-box" style="display: flex !important; align-items: center !important">
          <div class="hidden-sm-and-down contenedor-flex card-sumate">
            <p class="msj_cultura texto-sumate">{{ $t('comercial.title_1') }} <span style="color: #d35915" v-html="$t('comercial.title_2')"></span></p>
          </div>
        </el-col>
        <el-col :md="10" :sm="24" :xs="24" class="hidden-sm-and-down columna heigh-contenedor" style="display: flex !important; align-items: center !important">
          <div class="hidden-sm-and-down" style="/* o la medida que estés usando */ position: relative">
            <el-button class="title2" style="transform: translate(-14%, 0%)" type="warning" @click="showForm" v-html="$t('comercial.btn_comercial')"></el-button>
          </div>
        </el-col>
      </div>
    </el-row>
    <el-row style="background-color: #ececee" class="hidden-md-and-up">
      <el-col :md="14" :sm="24" :xs="24" class="heigh-contenedor" style="padding: 0% 10%; display: flex !important; align-items: center !important">
        <div class="contenedor-flex card-sumate">
          <p class="msj_cultura texto-sumate">{{ $t('comercial.title_1') }} <span style="color: #d35915" v-html="$t('comercial.title_2')"></span></p>
        </div>
      </el-col>
      <el-col :md="10" :sm="24" :xs="24" class="columna heigh-contenedor" style="display: grid !important; align-items: center !important">
        <el-button style="width: 100%" class="title2" type="warning" @click="showForm" v-html="$t('comercial.btn_comercial')"></el-button>
      </el-col>
    </el-row>
    <div style="background-color: #ececee" v-if="showFormulario">
      <div class="hidden-xs-only">
        <el-row :gutter="20" style="padding: 5% 10%"
          ><el-col style="border: 0px solid #0000001f">
            <h2 style="color: #d35915">
              <center>{{ $t('comercial.title_formulario') }}</center>
            </h2>
            <el-form label-position="top" :model="formSolicitud" ref="formSolicitud" :rules="rules">
              <el-row :gutter="20" style="padding: 0px 20px">
                <el-col :md="8" :sm="12" :xs="24">
                  <el-form-item size="small" :label="$t('comercial.campos_form[0]')" prop="razon_social">
                    <el-input v-model="formSolicitud.razon_social" :placeholder="$t('comercial.placeholder[0]')" clearable :disabled="sendForm" ref="razon"></el-input> </el-form-item
                ></el-col>
                <el-col :md="8" :sm="12">
                  <el-form-item size="small" :label="$t('comercial.campos_form[1]')" prop="denominacion">
                    <el-input v-model="formSolicitud.denominacion" :placeholder="$t('comercial.placeholder[1]')" clearable :disabled="sendForm"></el-input> </el-form-item
                ></el-col>
                <el-col :md="4">
                  <el-form-item size="small" :label="$t('comercial.campos_form[2]')" prop="provincia">
                    <el-select v-model="formSolicitud.provincia" :placeholder="$t('comercial.placeholder[2]')" style="width: 100%" clearable :disabled="sendForm" filterable>
                      <el-option v-for="res in provincias" :key="res" :label="res" :value="res"> {{ res }}</el-option>
                    </el-select>
                  </el-form-item></el-col
                >
                <el-col :md="4">
                  <el-form-item size="small" :label="$t('comercial.campos_form[3]')" prop="segmento">
                    <el-select v-model="formSolicitud.segmento" :placeholder="$t('comercial.placeholder[3]')" style="width: 100%" clearable :disabled="sendForm" filterable>
                      <el-option v-for="res in segmentos" :key="res" :label="res" :value="res"> {{ res }}</el-option>
                    </el-select>
                  </el-form-item></el-col
                >
              </el-row>
              <el-row :gutter="20" style="padding: 0px 20px"
                ><el-col :md="24" :sm="24" :xs="24">
                  <el-form-item size="small" :label="$t('comercial.campos_form[4]')" prop="consulta">
                    <el-input
                      style="font-family: unset !important"
                      type="textarea"
                      :rows="2"
                      v-model="formSolicitud.consulta"
                      :placeholder="$t('comercial.placeholder[4]')"
                      clearable
                      :disabled="sendForm"></el-input> </el-form-item
                ></el-col>
              </el-row>
              <el-row :gutter="20" style="padding: 0px 20px">
                <el-col :md="6" :sm="12" :xs="24">
                  <el-form-item size="small" :label="$t('comercial.campos_form[5]')" prop="nombre">
                    <el-input v-model="formSolicitud.nombre" :placeholder="$t('comercial.placeholder[5]')" clearable :disabled="sendForm"></el-input> </el-form-item
                ></el-col>
                <el-col :md="6" :sm="12" :xs="24">
                  <el-form-item size="small" :label="$t('comercial.campos_form[6]')" prop="apellido">
                    <el-input v-model="formSolicitud.apellido" :placeholder="$t('comercial.placeholder[6]')" clearable :disabled="sendForm"></el-input> </el-form-item></el-col
                ><el-col :md="6" :sm="12" :xs="24">
                  <el-form-item size="small" :label="$t('comercial.campos_form[7]')" prop="email">
                    <el-input v-model="formSolicitud.email" :placeholder="$t('comercial.placeholder[7]')" clearable :disabled="sendForm"></el-input> </el-form-item></el-col
                ><el-col :md="6" :sm="12" :xs="24">
                  <el-form-item size="small" :label="$t('comercial.campos_form[8]')" prop="celular">
                    <el-input
                      v-model.number="formSolicitud.celular"
                      :maxlength="12"
                      :placeholder="$t('comercial.placeholder[8]')"
                      clearable
                      :disabled="sendForm"></el-input> </el-form-item></el-col
              ></el-row>
              <el-row :gutter="20" style="margin-top: 2%"
                ><el-col>
                  <el-form-item style="text-align: center">
                    <el-button
                      type="warning"
                      style="font-family: 'MONTSERRAT-WHT'; background-color: #d35915"
                      @click="submitForm('formSolicitud')"
                      icon="el-icon-thumb"
                      :loading="sendForm"
                      >{{ $t('sumate.campos_form[8]') }}</el-button
                    >
                    <el-button type="default" style="font-family: 'MONTSERRAT-WHT'" @click="resetForm('formSolicitud')" icon="el-icon-close" :disabled="sendForm">{{
                      $t('sumate.campos_form[9]')
                    }}</el-button>
                  </el-form-item></el-col
                >
              </el-row>
            </el-form>
          </el-col></el-row
        >
      </div>
      <div class="hidden-sm-and-up" style="padding: 15% 10%; display: grid; align-items: center; margin-top: 0%">
        <el-row :gutter="20"
          ><el-col>
            <h3 style="color: #d35915">
              <center>{{ $t('comercial.title_formulario') }}</center>
            </h3>
            <el-form label-position="top" :model="formSolicitud" ref="formSolicitud" :rules="rules">
              <el-row :gutter="20">
                <el-col :md="8" :sm="12" :xs="24">
                  <el-form-item size="small" :label="$t('comercial.campos_form[0]')" prop="razon_social">
                    <el-input v-model="formSolicitud.razon_social" :placeholder="$t('comercial.placeholder[0]')" clearable :disabled="sendForm" ref="razon"></el-input> </el-form-item
                ></el-col>
                <el-col :md="8" :sm="12">
                  <el-form-item size="small" :label="$t('comercial.campos_form[1]')" prop="denominacion">
                    <el-input v-model="formSolicitud.denominacion" :placeholder="$t('comercial.placeholder[1]')" clearable :disabled="sendForm"></el-input> </el-form-item
                ></el-col>
                <el-col :md="4">
                  <el-form-item size="small" :label="$t('comercial.campos_form[2]')" prop="provincia">
                    <el-select v-model="formSolicitud.provincia" :placeholder="$t('comercial.placeholder[2]')" style="width: 100%" clearable :disabled="sendForm">
                      <el-option v-for="res in provincias" :key="res" :label="res" :value="res"> {{ res }}</el-option>
                    </el-select>
                  </el-form-item></el-col
                >
                <el-col :md="4">
                  <el-form-item size="small" :label="$t('comercial.campos_form[3]')" prop="segmento">
                    <el-select v-model="formSolicitud.segmento" :placeholder="$t('comercial.placeholder[3]')" style="width: 100%" clearable :disabled="sendForm">
                      <el-option v-for="res in segmentos" :key="res" :label="res" :value="res"> {{ res }}</el-option>
                    </el-select>
                  </el-form-item></el-col
                >
              </el-row>
              <el-row :gutter="20"
                ><el-col :md="24" :sm="24" :xs="24">
                  <el-form-item size="small" :label="$t('comercial.campos_form[4]')" prop="consulta">
                    <el-input v-model="formSolicitud.consulta" :placeholder="$t('comercial.placeholder[4]')" clearable :disabled="sendForm"></el-input> </el-form-item
                ></el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :md="6" :sm="12" :xs="24">
                  <el-form-item size="small" :label="$t('comercial.campos_form[5]')" prop="nombre">
                    <el-input v-model="formSolicitud.nombre" :placeholder="$t('comercial.placeholder[5]')" clearable :disabled="sendForm"></el-input> </el-form-item
                ></el-col>
                <el-col :md="6" :sm="12" :xs="24">
                  <el-form-item size="small" :label="$t('comercial.campos_form[6]')" prop="apellido">
                    <el-input v-model="formSolicitud.apellido" :placeholder="$t('comercial.placeholder[6]')" clearable :disabled="sendForm"></el-input> </el-form-item></el-col
                ><el-col :md="6" :sm="12" :xs="24">
                  <el-form-item size="small" :label="$t('comercial.campos_form[7]')" prop="email">
                    <el-input v-model="formSolicitud.email" :placeholder="$t('comercial.placeholder[7]')" clearable :disabled="sendForm"></el-input> </el-form-item></el-col
                ><el-col :md="6" :sm="12" :xs="24">
                  <el-form-item size="small" :label="$t('comercial.campos_form[8]')" prop="celular">
                    <el-input
                      v-model.number="formSolicitud.celular"
                      :maxlength="12"
                      :placeholder="$t('comercial.placeholder[8]')"
                      clearable
                      :disabled="sendForm"></el-input> </el-form-item></el-col
              ></el-row>
              <el-row :gutter="20" style="margin-top: 2%"
                ><el-col>
                  <el-form-item style="text-align: center">
                    <el-button
                      type="warning"
                      size="small"
                      style="font-family: 'MONTSERRAT-WHT'; background-color: #d35915"
                      @click="submitForm('formSolicitud')"
                      icon="el-icon-thumb"
                      :loading="sendForm"
                      >{{ $t('sumate.campos_form[8]') }}</el-button
                    >
                    <el-button type="default" size="small" style="font-family: 'MONTSERRAT-WHT'" @click="resetForm('formSolicitud')" icon="el-icon-close" :disabled="sendForm">{{
                      $t('sumate.campos_form[9]')
                    }}</el-button>
                  </el-form-item></el-col
                >
              </el-row>
            </el-form>
          </el-col></el-row
        >
      </div>
    </div>
  </div>
</template>
<script>
import Swal from 'sweetalert2'
import { HTTP } from '@/axios.js'

export default {
  data() {
    return {
      images: require('@/assets/fotos/07.jpg'),
      showFormulario: false,
      formSolicitud: {
        nombre: null,
        apellido: null,
        email: null,
        razon_social: null,
        consulta: null,
        denominacion: null,
        segmento: null,
        celular: null,
        provincia: null,
      },
      provincias: [
        'Capital Federal',
        'Buenos Aires',
        'Buenos Aires GBA Norte',
        'Buenos Aires GBA Oeste',
        'Buenos Aires GBA Sur',
        'Catamarca',
        'Córdoba',
        'Corrientes',
        'Chaco',
        'Chubut',
        'Entre Ríos',
        'Formosa',
        'Jujuy',
        'La Pampa',
        'La Rioja',
        'Mendoza',
        'Misiones',
        'Neuquén',
        'Río Negro',
        'Salta',
        'San Juan',
        'San Luis',
        'Santa Cruz',
        'Santa Fe',
        'Santiago del Estero',
        'Tierra del Fuego',
        'Tucumán',
      ],
      segmentos: ['Salud', 'Cosmética', 'Salud animal', 'Otros'],
      rules: {
        nombre: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        apellido: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        email: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' },
          { type: 'email', message: 'Ingrese una direccion de email correcta' },
        ],
        razon_social: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        consulta: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        denominacion: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        segmento: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        celular: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' },
          { type: 'number', message: 'Sólo puede ingresar números' },
        ],
        provincia: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
      },
      sendForm: false,
    }
  },
  methods: {
    showForm() {
      this.showFormulario = !this.showFormulario
      setTimeout(() => {
        this.$refs.razon.focus()
      }, 100)
      this.$nextTick(() => {
        this.$refs.detalle.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      })
    },
    resetForm(formName) {
      this.showFormulario = false
      this.$refs[formName].resetFields()
      this.showFormulario = false
      this.formSolicitud.nombre = null
      this.formSolicitud.apellido = null
      this.formSolicitud.dni = null
      this.formSolicitud.email = null
      this.formSolicitud.razon_social = null
      this.formSolicitud.consulta = null
      this.formSolicitud.denominacion = null
      this.formSolicitud.segmento = null
      this.formSolicitud.celular = null
    },
    submitForm(formName) {
      this.sendForm = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          HTTP.post('/webLogin/enviarFormulario', this.formSolicitud).then((res) => {
            console.log(res.data)
            Swal.fire({
              title: 'Formulario enviado!',
              text: 'Gracias, pronto nos comunicaremos con usted.',
              icon: 'success',
              draggable: true,
              // confirmButtonText: 'Cool',
            })
            setTimeout(() => {
              this.resetForm('formSolicitud')
            }, 1000)
            this.sendForm = false
          })
        } else {
          this.sendForm = false
        }
      })
    },
  },
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Sura:wght@400;700&display=swap');
.el-textarea__inner {
  font-family: inherit !important;
}
:root {
  --src: url(https://images.unsplash.com/photo-1554620121-59e7f3f6e3a4?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy);
  /* --size: 35vmin; */
  /* --space: 100vmin; */
  --duration: 300ms;
  /* --ease-out: cubic-bezier(0.25, 1, 0.5, 1); */
  /* --bounce-out: cubic-bezier(0.34, 1.56, 0.64, 1); */
}

/* body {
  display: grid;
  place-items: center;
  grid-gap: var(--space);
  margin: 0 auto;
  padding: var(--space);
  font-family: 'Sura', sans-serif;
  color: white;
  background-color: rgb(29, 30, 34);
} */
.heigh-contenedor,
.promo .image-wrapper {
  height: 40vh;
}
.padding-box {
  padding: 0% 10%;
}
.title {
  --font-size: calc(var(--size) / 8);

  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
  bottom: 0;
  font-size: var(--font-size);
  /* font-weight: 700; */
  line-height: 1.2;
  white-space: nowrap;
  transform: translate(-10%, -50%);
  transition: transform var(--duration) var(--ease-out);
  pointer-events: none;
  margin-bottom: 18%;
  /* background-color: orange; */
}

.title::after {
  content: attr(data-cta);
  display: inline-block;
  margin-left: 1.5vmin;
  font-size: calc(var(--font-size) / 3.25);
  /* font-weight: 400; */
  letter-spacing: 0.125vmin;
  opacity: 0;
  transform: translateX(-25%);
  transition:
    transform var(--duration) var(--ease-out),
    opacity var(--duration) var(--ease-out);
}

.image-wrapper {
  /* width: var(--size); */
  /* height: var(--size); */
  overflow: hidden;
  clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 0 50%, 0% 0%);
  transition:
    transform var(--duration) var(--ease-out),
    clip-path var(--duration) var(--ease-out);
}

.image-wrapper img {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
  float: inline-end;
  display: block;
  /* transform: translateX(-10%);
  transition: transform var(--duration) var(--ease-out); */
}

.image-wrapper::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--overlay-color);
  mix-blend-mode: multiply;
  opacity: 0;
  transform: translateZ(0);
  transition: opacity var(--duration) var(--ease-out);
}

/* .promo:hover img {
  transform: translateX(0);
} */

/* .promo:hover .image-wrapper {
  clip-path: polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%);
  transform: translateX(25%);
  transition-timing-function: var(--bounce-out);
} */

/* .promo:hover .title {
  transform: translate(5%, -50%);
  transition-timing-function: var(--bounce-out);
}

.promo:hover .title::after {
  opacity: 1;
  transform: translateX(0);
  transition-timing-function: var(--bounce-out);
}

.promo:hover .image-wrapper::after {
  opacity: 1;
} */
.columna {
  background-image: url('~@/assets/fotos/07.jpg') !important; /* ruta válida Vue 2 */
  background-size: cover; /* para que cubra toda la columna */
  background-position: center; /* centrar la imagen dentro */
  background-repeat: no-repeat;
}
.contenedor-imagen {
  width: 100%; /* Ocupa todo el ancho de la columna */
  height: 100%; /* Ajusta el alto según necesites */
  overflow: hidden; /* Asegura que la imagen no se salga del contenedor */
}

.contenedor-imagen img {
  width: 100%;
  height: 80%;
  object-fit: cover; /* Llena el contenedor manteniendo la relación de aspecto */
}
.texto-left {
  display: grid;
  align-items: center;
  margin-top: 18%;
}
.button-asesora {
  background-color: #d35915 !important;
  /* font-size: 20px; */
  text-align: left !important;
  padding: 1% 5%;
}
.texto-comercial {
  padding: 0px 20%;
  color: #706f6e;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'roboto-regular';
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .texto-comercial {
    font-size: 26px;
  }
  .title2 {
    font-size: 25px !important;
  }
  .texto-left {
    /* margin-top: 10%; */
    margin-bottom: 10%;
    margin-top: 13%;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .texto-left {
    display: grid;
    align-items: center;
    /* margin-top: 12%; */
  }
  .texto-comercial {
    font-size: 24px;
  }
  .button-asesora {
    font-size: 23px !important;
    margin-bottom: 8% !important;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .texto-comercial {
    font-size: 21px !important;
  }
  .texto-left {
    display: grid;
    align-items: center;
    /* margin-top: 12%; */
  }
  .button-asesora {
    font-size: 20px !important;
    margin-bottom: 11% !important;
  }
  .bg-nosotros-2 {
    padding: 4% 11% 4% 11%;
  }
  .title {
    margin-bottom: 13%;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .bg-nosotros-2 {
    padding: 7% 11% 7% 11%;
  }
  .texto-comercial {
    font-size: 21px;
    padding: 0px 15% 0px 20%;
  }
  .texto-left {
    display: grid;
    align-items: center;
    margin-top: 12%;
  }
  .button-asesora {
    font-size: 20px;
  }
  .title2 {
    /* margin-bottom: 15%; */
  }
}
@media (orientation: landscape) and (max-height: 500px) {
  .heigh-contenedor,
  .promo .image-wrapper {
    height: 60vh !important;
  }
  .bg-nosotros-2 {
    padding: 10% 10% 10% 10% !important;
  }
}
@media screen and (min-width: 375px) and (max-width: 767px) {
  .texto-comercial {
    font-size: 20px;
    padding: 0px 10%;
  }
  .button-asesora {
    font-size: 15px;
  }
  .title2 {
    font-size: 15px !important;
    /* margin-left: 24%; */
    /* margin-bottom: 15%; */
    /* padding: 1% 10%; */
  }
  .image-wrapper img {
    position: relative;
    /* width: 70vh; */
    /* height: 30vh !important; */
    height: auto !important;

    -o-object-fit: cover;
    object-fit: fill;
    float: inline-end;
  }
  .bg-nosotros-2 {
    padding: 12% 10% 12% 10%;
  }
  .heigh-contenedor,
  .promo .image-wrapper {
    height: 30vh;
  }
}
@media (max-width: 374px) {
  .texto-comercial {
    font-size: 20px;
    padding: 0px 10%;
  }
  .button-asesora {
    font-size: 15px;
  }
  .title2 {
    font-size: 15px !important;
    /* margin-left: 24%;
    margin-bottom: 15%; */
    /* padding: 1% 10%; */
  }
  .image-wrapper img {
    position: relative;
    /* width: 70vh; */
    /* height: 30vh !important; */
    height: auto !important;
    -o-object-fit: cover;
    object-fit: fill;
    float: inline-end;
  }
  .bg-nosotros-2 {
    padding: 12% 10% 12% 10%;
  }
  .heigh-contenedor,
  .promo .image-wrapper {
    height: 30vh;
  }
}
</style>
<style scoped>
.el-button {
  border-radius: 0px;
}
</style>
